import React, {PureComponent} from 'react';

import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import style from './IndexUpdated.css';
import Slider from "react-slick";

import {FireIcon} from '../Icons';
import LiveUpdateItem from "./LiveUpdateItem";


const TrendingItem = ({item}) => {
  return <div className={style.item}>
    {item.title}
  </div>
}

class IndexUpdated extends PureComponent {

  render() {
    let {updatedLives} = this.props;
    console.log('updatedLives', updatedLives)

    const settings = {
      dots: true,
      vertical: true,
      autoplay: false,
      autoplaySpeed: 10*1000,
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 5,
    }

    return (
        <div>
          {/*<Slider {...settings}>*/}
            {updatedLives.list.map((item, idx) => {
              return <LiveUpdateItem live={item} key={'id' + idx}/>
            })}
          {/*</Slider>*/}
        </div>
    )
  }
}

export default connect(({updatedLives}) => ({updatedLives}))(IndexUpdated);
